import PaymentBreakdown from "@/components/inventory/BatchTransfer/BuildBlocks/PaymentBreakdown/PaymentBreakdown.component";
import { InboundTransferDefault } from "@/components/inventory/BatchTransfer/declarations";
import { BatchTransfer } from "@/interfaces/batchTransferManager";
import cloneDeep from "lodash/cloneDeep";
import pick from "lodash/pick";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { paymentMethodsModelKeys } from "../../ModelKeys";
import TransferStep from "../../TransferStep.mixin";
import Template from "./InboundTransferPaymentMethods.template.vue";
interface StepModel {
  payment_methods_breakdown: BatchTransfer.PaymentMethodsBreakdown;
}

@Component({
  mixins: [Template],
  components: {
    "payment-breakdown": PaymentBreakdown
  }
})
export default class InboundTransferPaymentMethods extends Mixins(
  TransferStep
) {
  @Prop() public transfer!: BatchTransfer.InboundTransfer;
  public modelKeys = paymentMethodsModelKeys;
  public model: StepModel = pick(
    InboundTransferDefault,
    this.modelKeys
  ) as StepModel;

  /**
   * Gets payments
   */
  public get payments() {
    return this.transfer.payment_methods_breakdown;
  }

  /**
   * Handler for payment change event
   * @param {BatchTransfer.PaymentMethodsBreakdow} payments
   */
  public paymentsChange(payments: BatchTransfer.PaymentMethodsBreakdown) {
    this.model = { payment_methods_breakdown: cloneDeep(payments) };
    this.transferChanges();
  }

  protected mounted() {
    this.model = {
      payment_methods_breakdown: cloneDeep(
        this.transfer.payment_methods_breakdown
      )
    };
  }
}
